import axios from 'axios';

// Marketing › Comunidad (backend de LisualPro): GET /api/comunidad, POST /api/comunidad/contacto, POST /api/comunidad/visibilidad
const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

export const comunidadApi = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/comunidad`, timeout: 20000 });
comunidadApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const leerComunidad = () => comunidadApi.get('/').then((r) => r.data);
export const pedirContacto = (empresaId, mensaje) => comunidadApi.post('/contacto', { empresaId, mensaje }).then((r) => r.data);
export const cambiarVisibilidad = (visible) => comunidadApi.post('/visibilidad', { visible }).then((r) => r.data);
